import Immutable, { List } from 'immutable';
import StudentPerformance from './StudentPerformance';

const GroupPerformanceRecord = Immutable.Record({
  startUnitNumber: undefined,
  endUnitNumber: undefined,
  studentsPerformance: new List(),
});

class GroupPerformance extends GroupPerformanceRecord { }

const reviver = ([key, seq]) => {
  if (! seq) return [key, seq];
  switch (key) {
    case 'studentsPerformance':
      return [key, new List(seq.map(StudentPerformance.create))];
    default:
      return [key, Immutable.fromJS(seq)];
  }
};

GroupPerformance.create = (data) =>
  new GroupPerformance(data).mapEntries(reviver);

export default GroupPerformance;



// WEBPACK FOOTER //
// ./data/GroupPerformance/model.js